import { useExtraPositionsInformations } from "@hooks/HRM/positions/useExtraPositionsInformations";
import {
  ExtraPositionInformationsPageHeader,
  ExtraPositionInformationsTable,
} from "./components";

const ExtraPositionInformations = () => {
  const {
    extraPositionsInfo,
    pagination,
    handleQuery,
    downloadReport,
    isLoading,
  } = useExtraPositionsInformations();
  return (
    <div className="d-flex flex-column gap-10 p-10">
      <ExtraPositionInformationsPageHeader
        downloadReport={downloadReport}
        isLoading={isLoading}
      />
      <ExtraPositionInformationsTable
        extraPositionsInfo={extraPositionsInfo}
        pagination={pagination}
        handleQuery={handleQuery}
      />
    </div>
  );
};

export default ExtraPositionInformations;
